module.exports = __webpack_public_path__ + "ceed7616b46a6aa0eaaf9f19e040dbda.pdf";